import { DevotionalElement, GifSearch, ImageSearch } from 'grow.client';
import produce from 'immer';
import { useAppDispatch } from '../../../../../store/store';
import { setDevotionalElement } from '../../../../../store/slices/devotionalBuilderSlice/devotionalBuilderHistorySlice';
import { PhotoSearchGrid } from '../../../ImageSearchGrid/PhotoSearchGrid';

interface Props {
    devotionalElement: DevotionalElement
    closeModal: () => void
}

export const ImageSettings: React.FC<Props> = ({ devotionalElement, closeModal }) => {
    const dispatch = useAppDispatch();

    const selectImage = (image: ImageSearch | GifSearch) => {
        const updatedDevotionalElement = produce(devotionalElement, draft => {
            draft.imageElement = {
                height: image.height,
                imageId: image.id,
                url: image.imageUrl,
                width: image.width
            };
        });
        dispatch(setDevotionalElement(updatedDevotionalElement));
        closeModal();
    }

    return (
        <div>
            <PhotoSearchGrid
                columnCount={3}
                scrollableTargetId="image-settings-scrollable-target"
                selectImage={selectImage}
            />
        </div>
    );
}